<script setup>
import ClickableCell from '@/components/lists/ClickableCell';
import {computed} from 'vue';
import {ladderCardLine} from '~/utils/competitionCard';
// Props
const props = defineProps({
  ladder: {
    type: Object,
    default: () => null
  }
});
// X213: "Ladder · Tennis · 10 players"; nobody yet = "Open to join" when it has a link
const subtitle = computed(() => ladderCardLine(props.ladder));
</script>

<template>
  <clickable-cell
      icon="mdi-ladder"
      tone="ladder"
      class="mb-3"
      :to="{ name: 'LadderDetail', params: { ladderId: ladder.id } }"
      :title="ladder.name"
      :subtitle="subtitle"
      subtitle-one-line
  />
</template>
